import { Link, NavLink } from "react-router-dom";
import { useCart } from "../context/CartContext";

export default function Navbar(){
    const { totalItems } = useCart();

    return <nav
        className="navbar navbar-expand-lg navbar-dark bt-dark mb-4"
    >
        <div
            className="container"
        >
            <Link
                className="navbar-brand"
                to="/"
            ></Link>
            <button
                className="navbar-toggler"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target="#navContent"
            >
                <span
                    className="navbar-goggler-icon"
                ></span>
            </button>
            <div
                className="collapse navbar-collapse"
                id="navContent"
            >
                <ul
                    className="navbar-nav me-auto"
                >
                    <li
                        className="nav-item"
                    >
                        <NavLink
                            className="nav-link"
                            to="/"
                            end
                        >Home</NavLink>
                    </li>
                </ul>

                <ul
                    className="navbar-nav ms-auto"
                >
                    <li
                        className="nav-item"
                    >
                        <NavLink
                            className="nav-link d-flex align-items-center"
                            to="/cart"
                        >
                            <i
                                className="bi bi-cart3 me-1"
                            ></i> Cart

                            {totalItems > 0 && <span
                                className="badge bg-success ms-2"
                            >{totalItems}</span>}
                        </NavLink>
                    </li>
                </ul>
            </div>
            
        </div>
    </nav>
}